if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }

      getSwiper() {
        const el = this.querySelector('.swiper');
        if (el && el.swiper) return el.swiper;

        const wc = this.querySelector('swiper-component');
        if (wc && wc.swiper) return wc.swiper;

        const container = this.querySelector('.swiper__container');
        if (container && container.swiper) return container.swiper;

        return null;
      }

      setActiveMedia(mediaId) {
        if (!mediaId) return;

        const rawId = String(mediaId);
        const parsedId = rawId.includes('-') ? rawId.split('-').pop() : rawId;

        const target =
          this.querySelector(`[data-media-id="${parsedId}"]`) ||
          this.querySelector(`[id*="product-${parsedId}-"]`);
        if (!target) return;

        const swiper = this.getSwiper();
        if (swiper) {
          const slides = Array.from(swiper.slides || []);
          const slideEl = target.closest('.swiper-slide') || target;
          let slideIndex = slides.indexOf(slideEl);

          if (slideIndex === -1) {
            slideIndex = slides.findIndex(
              (slide) =>
                slide.getAttribute('data-media-id') === parsedId ||
                slide.querySelector(`[data-media-id="${parsedId}"]`)
            );
          }

          if (slideIndex !== -1) {
            swiper.slideTo(slideIndex);
          }

          return;
        }

        const container = target.closest('.product-media-container') || target;
        if (container && typeof container.scrollIntoView === 'function') {
          container.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
  );
}
